import React, { useRef, useEffect, useCallback, useContext } from 'react';
import { Context } from "..";

export default function useDesignerDispatcher() {

    const context = useContext(Context);

    const dispatcher = useCallback((name, data) => {
        context.eventEmitter.emit(name, data);
    }, [context.eventEmitter]);

    return dispatcher;
}